import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-layout">
              <div className="hero-left">
                <h1 className="hero-title">
                  <span className="hero-title-line1">About</span>
                  <span className="hero-title-line2">DHRTI MAA</span>
                </h1>
              </div>
              <div className="hero-center">
                <p className="hero-subtitle">Inspired By Nature</p>
              </div>
              <div className="hero-right">
                <p className="hero-description">
                  Your trusted partner for quality fertilizers, gardening tools, accessories and gardening needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="company-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2 className="section-title">Our Story</h2>
              <p className="story-description">
                DHRTI MAA was founded with a simple yet powerful vision: to bring the best of nature 
                to every garden and farm. We believe that healthy soil and plants are the foundation 
                of sustainable agriculture and beautiful gardens.
              </p>
              <p className="story-description">
                Our journey began with a passion for organic farming and a commitment to providing 
                high-quality fertilizers and gardening products that work in harmony with nature. 
                Today, we serve thousands of customers across the region, helping them achieve 
                their gardening and farming goals.
              </p>
            </div>
            <div className="story-image">
              <img src="/logo.png" alt="DHRTI MAA" className="story-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="mission-values">
        <div className="container">
          <div className="mission-content">
            <div className="mission-card">
              <h3 className="card-title">Our Mission</h3>
              <p className="card-description">
                To provide high-quality, natural fertilizers and gardening products that help 
                our customers grow healthy, productive plants while respecting the environment.
              </p>
            </div>
            <div className="mission-card">
              <h3 className="card-title">Our Vision</h3>
              <p className="card-description">
                To be the leading provider of organic gardening solutions, promoting sustainable 
                agriculture and helping create a greener, healthier world.
              </p>
            </div>
            <div className="mission-card">
              <h3 className="card-title">Our Values</h3>
              <p className="card-description">
                Quality, sustainability, customer satisfaction, and environmental responsibility 
                are the core values that guide everything we do.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose DHRTI MAA?</h2>
            <p className="section-subtitle">What sets us apart from the competition</p>
          </div>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">🌱</div>
              <h3 className="feature-title">Natural Products</h3>
              <p className="feature-description">
                All our fertilizers and products are made from natural, organic ingredients 
                that are safe for your plants and the environment.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🏆</div>
              <h3 className="feature-title">Quality Guarantee</h3>
              <p className="feature-description">
                We stand behind the quality of our products with a satisfaction guarantee. 
                If you're not happy, we'll make it right.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">👨‍🌾</div>
              <h3 className="feature-title">Expert Support</h3>
              <p className="feature-description">
                Our team of gardening experts is here to help you choose the right products 
                and provide advice for your specific needs.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🚚</div>
              <h3 className="feature-title">Fast Delivery</h3>
              <p className="feature-description">
                We ensure quick and reliable delivery of your orders, so you can start 
                gardening without delay.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Banner */}
      <section className="contact-banner">
        <div className="container">
          <div className="banner-content">
            <div className="banner-text">
              <h2 className="banner-title">Need Help with Your Garden?</h2>
              <p className="banner-description">
                Our experts are here to help you choose the right products and provide gardening advice.
              </p>
            </div>
            <div className="banner-actions">
              <Link to="/contact" className="btn btn-primary">
                Contact Us
              </Link>
              <a href="tel:+918890060211" className="btn btn-primary">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
